const CONFIG_DEFAULT = {
    theme: "web",
    assetPath: "./themes/"
};

const setTheme = (theme) => {
    window.trumpf.ux.theme = theme;
    const styleElement = document.createElement("style");
    styleElement.innerHTML = `:root { --trumpf-ux-theme: ${theme}; }`;
    document.head.appendChild(styleElement);
    const event = new Event("uxThemeChange");
    window.dispatchEvent(event);
};

class BodyMutationObserver {
    constructor() {
        this.observer = new MutationObserver(this.handleMutation);
        this.observeBody();
    }
    observeBody() {
        const targetNode = document.body;
        const config = { attributes: true, attributeFilter: ["class", "dir"] };
        this.observer.observe(targetNode, config);
    }
    handleMutation(mutationsList) {
        for (const mutation of mutationsList) {
            if (mutation.type === "attributes") {
                // be sure, we switch only at theme change
                if (document.body.classList.contains("ux-theme-web")) {
                    setTheme("web");
                }
                else if (document.body.classList.contains("ux-theme-responsive")) {
                    setTheme("responsive");
                }
            }
        }
    }
    disconnect() {
        this.observer.disconnect();
    }
}

const appGlobalScript = async () => {
    if (window.trumpf) {
        // Check if Trumpf namespaces present
        if (window.trumpf.ux) {
            // patch default values to config default
            window.trumpf.ux = Object.assign(Object.assign({}, CONFIG_DEFAULT), window.trumpf.ux);
        }
        else {
            window.trumpf.ux = Object.assign({}, CONFIG_DEFAULT);
        }
    }
    else {
        // Create Trumpf namespace
        window.trumpf = {
            ux: Object.assign({}, CONFIG_DEFAULT)
        };
    }
    new BodyMutationObserver();
};

const globalScripts = appGlobalScript;

export { globalScripts as g };

